import { combineReducers } from 'redux';

import {
	CHANGE_COLOR
} from '../actions/backgroundColor';

/**
 * Background color changer
 * @param state
 * @param action
 * @returns {Array}
 */
function backgroundReducer(state = "#FFFFFF", action) {
	switch(action.type) {
		case CHANGE_COLOR:
			return action.data.color;
		default:
			return state;
	}
}

export default combineReducers({
	"color": backgroundReducer
});


// WEBPACK FOOTER //
// ./src/reducers/background.js